import { defineClientModule, type ModuleRoute } from '@/app/module';
import { copy } from './copy';

/**
 * studio. AI full body portraits: intake, jobs, presets, set as card.
 * See docs/MODULE-GUIDE-client.md. Keep this file light: data and lazy imports only.
 */
const routes: ModuleRoute[] = [
  { path: '/me/studio', screen: () => import('./screens/Studio'), tab: 'me' },
  { path: '/me/studio/new', screen: () => import('./screens/StudioNew'), tab: 'me' },
  { path: '/me/studio/:jobId', screen: () => import('./screens/StudioJob'), tab: 'me' },
];

export default defineClientModule({
  name: 'studio',
  routes,
  meSections: [{ id: 'studio', order: 10, title: copy.entry.title, component: () => import('./parts/StudioEntry') }],
});
